@if (groupings) {
  <div id="grouping-toggle" class="float-end pb-2">
    <small class="ps-3">{{ 'xml-report.chart.group-on' | translate}}:&ensp;</small>
    @if (groupings.length > 0) {
      <select id="grouping-select" class="form-select form-select-sm"
        [(ngModel)]="currentGrouping"
        (change)="changedGrouping.emit(currentGrouping)">
        @for (grouping of groupings; track grouping) {
          <option
            [ngValue]="grouping">
            {{grouping}}
          </option>
        }
      </select>
    }
  </div>
}